import { api } from '../api';

export class ProductsService {
  static async getProducts() {
    return api.get('/product/products');
  }

  static async getProductById({ id }) {
    return api.get(`product/product/${id}`);
  }

  static async updateProduct({ id, changesProduct }) {
    return api.put(`product/${id}`, changesProduct);
  }
}
